import {v4 as uuidv4} from 'uuid';
import img1 from '../../assets/img/products/RawCotton.jpg';
import img2 from '../../assets/img/products/Consumer Edible Oils.jpg';
import img3 from '../../assets/img/products/Commercial Oils.jpg';
import img4 from '../../assets/img/products/OilCakesCattleFeeds.jpg';
import img5 from '../../assets/img/products/De-OiledCakes.jpg';
import img6 from '../../assets/img/products/Oil seeds _ Grains _ Pulses.jpg';
import img7 from '../../assets/img/products/Cotton Yarns.jpg';


const teamThreeData = [
    {
        id: uuidv4(),
        img: img1,
        name: 'Raw Cotton  ',
        link:"/raw_cotton"
        // designation: 'Contructor',
        // fb: '#',
        // twitter: '#',
        // insta: '#',
        // linkedIn: '#'
    },

    {
        id: uuidv4(),
        img: img2,
        name: 'Consumer Edible Oils',
         link:"/ConsumerEdibleOils"
        // designation: 'Engineer',
        // fb: '#',
        // twitter: '#',
        // insta: '#',
        // linkedIn: '#'
    },

    {
        id: uuidv4(),
        img: img3,
        name: 'Commercial Oils',
         link:"/CommercialOils"
        // designation: 'Mechanic',
        // fb: '#',
        // twitter: '#',
        // insta: '#',
        // linkedIn: '#'
    },

    {
        id: uuidv4(),
        img: img4,
        name: 'Oil Cakes (Cattle Feeds)',
         link:"/OilCakes"
        // designation: 'Contractor',
        // fb: '#',
        // twitter: '#',
        // insta: '#',
        // linkedIn: '#'
    },

    {
        id: uuidv4(),
        img: img5,
        name: 'Oil Meals (Solvent Extracted De-Oiled Cakes)',
         link:"/OilMeals"
        // designation: 'Manager',
        // fb: '#',
        // twitter: '#',
        // insta: '#',
        // linkedIn: '#'
    },

    {
        id: uuidv4(),
        img: img6,
        name: 'Oil seeds / Grains / Pulses',
         link:"/Seeds"
        // designation: 'Contractor',
        // fb: '#',
        // twitter: '#',
        // insta: '#',
        // linkedIn: '#'
    },
    {
        id: uuidv4(),
        img: img7,
        name: 'Cotton Yarns',
         link:"/CottonYarns"
        // designation: 'Contractor',
        // fb: '#',
        // twitter: '#',
        // insta: '#',
        // linkedIn: '#'
    },

]

export default teamThreeData;